<template>
  <div style="padding: 20px;">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="分销订单" name="first">
        <dis-order v-if="activeName==='first'"></dis-order>
      </el-tab-pane>
      <el-tab-pane label="待付款订单" name="second">
        <UnPay-order v-if="activeName === 'second'"></UnPay-order>
      </el-tab-pane>
      <el-tab-pane label="已付款订单" name="third">
        <paid-order v-if="activeName === 'third'"></paid-order>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import DisOrder from "./DisOrder.vue";
import PaidOrder from "./PaidOrder.vue";
import UnPayOrder from "./UnPayOrder.vue";

export default {
  name: "Index",
  components: {
    DisOrder, PaidOrder, UnPayOrder
  },
  data() {
    return {
      activeName: 'first'
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(this.activeName)
    }
  }
}
</script>


<style scoped>

</style>